// 模块
// export default Home;

import home_video from '../../assets/home/a.mov';

import React, { useState, useEffect, useRef } from 'react';
import 'swiper/css/navigation';

import logo from '../../assets/home/logo.png';
import bannertitle from '../../assets/home/bannertitle-mobile.png';
import bannertitle_mobile from '../../assets/home/bannertitle-mobile.png';
import home_video_img from '../../assets/home/home_video.png';
import home_video_gif from '../../assets/home/home.gif';
import './index.less';
import './index_new.less';
import './pad_new.less';

import { device } from "../../utils/index.js";
import {getHomeData, getNewsList} from '../../request/index.js';

import { VisibilityObserver } from "../../components/index.jsx";

// swiper banner
import { HsSwiper } from "../../components/index.jsx";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
import 'swiper/css';
import banner1 from '../../assets/home/banner1.jpg';
import banner2 from '../../assets/home/banner2.jpg';
import banner4 from '../../assets/home/banner4.jpg';
import banner5 from '../../assets/home/banner5.jpg';
import banner6 from '../../assets/home/banner6.jpg';

// classroom
import since1963 from '../../assets/home/since1963.png';
import oyako from '../../assets/home/oyako.png';
import spice from '../../assets/home/spice.png';
import spoon from '../../assets/home/spoon.png';
import tomatosoup from '../../assets/home/tomatosoup.png';
import housecurry from '../../assets/home/housecurry.png';
import currydish01 from '../../assets/home/currydish01.png';
import dah from '../../assets/home/dah.svg';
import curryill from '../../assets/home/curryill.webp';
import since_left_bottom from '../../assets/home/since_left_bottom.png';
import arrow from '../../assets/home/arrow.png';
import arrow_mobile_1 from '../../assets/home/arrow_mobile_1.png';
import arrow_mobile_2 from '../../assets/home/arrow_mobile_2.png';
import arrow_mobile_3 from '../../assets/home/arrow_mobile_3.png';
import left_arrow_1 from '../../assets/home/left_arrow_1.png';
import left_arrow_2 from '../../assets/home/left_arrow_2.png';
import left_arrow_3 from '../../assets/home/left_arrow_3.png';
import news_all from '../../assets/home/news-all.png';


// all cookbook
import recipetitle from '../../assets/home/recipetitle.png';
import menubutton_icon_red from '../../assets/home/menu-button-icon-red.svg';
import all_foods_banner from '../../assets/home/all_foods_banner.png'; // 全部食材banner
import all_foods_banner_2 from '../../assets/home/all_foods_banner-2.png'; // 全部食材banner
import bmd_package from '../../assets/home/bmd-package.png?v=1'; // 百梦多包装
import bmd_package_mobile from '../../assets/home/bmd-package-mobile.png';
import bmd_package_2_mobile from '../../assets/home/bmd-package-2-mobile.png';
import bmdlogo2x from '../../assets/home/bmdlogo2x-new.png'; // 百梦多logo
import button_see from '../../assets/home/button_see.png';
import two_line from '../../assets/home/two_line.png';

import gw_package from '../../assets/home/gw-package.png?v=1'; // 咖王包装
import gwlogo2x from '../../assets/home/gw-logo2x-new.png'; // 咖王logo
import talk_fukidashi_1 from '../../assets/home/talk-fukidashi-1.svg'; // 筷子1
import talk_fukidashi_2 from '../../assets/home/talk-fukidashi-2.svg'; // 筷子2


// all foods

import all_foods_1_top from '../../assets/home/all_foods_1_top.png';
import all_foods_2_top from '../../assets/home/all_foods_2_top.png';
import all_foods_3_top from '../../assets/home/all_foods_3_top.png';
import all_foods_4_top from '../../assets/home/all_foods_4_top.png';

import all_foods_1_bottom from '../../assets/home/all_foods_1_bottom.png';
import all_foods_2_bottom from '../../assets/home/all_foods_2_bottom.png';
import all_foods_3_bottom from '../../assets/home/all_foods_3_bottom.png';
import all_foods_4_bottom from '../../assets/home/all_foods_4_bottom.png';


// lineup
import sku_bmd_gw from '../../assets/home/sku-bmd-gw-new.png?v=2';
import sku_business from '../../assets/home/sku-business-new.png?v=2';
import sku_wdd from '../../assets/home/sku-wdd-new.png?v=2';
import sku_xq_fq from '../../assets/home/sku-xq-fq-new.png?v=2';
import lineuptitle from '../../assets/home/lineuptitle.png';

import size_mobile_1 from '../../assets/home/size_mobile_1.png';
import size_mobile_2 from '../../assets/home/size_mobile_2.png';

// about hs
import abouths from '../../assets/home/abouths.jpg';
import abouths_mobile from '../../assets/home/abouths-mobile.png';
import abouths_title from '../../assets/home/about-house-title.png';

// news
import news_left_1 from '../../assets/home/news-left-1.png';
import news_left_2 from '../../assets/home/news-left-2-effect.png';
import news_left_3 from '../../assets/home/news-left-3-effect.png';
import news_left_4 from '../../assets/home/news-left-4-effect.png';
import news_left_5 from '../../assets/home/news-left-5-effect.png';
import news_left_6 from '../../assets/home/news-left-6-effect.png';
import news_right_1 from '../../assets/home/news-right-1-effect.png';
import news_right_2 from '../../assets/home/news-right-2-effect.png';
import news_right_3 from '../../assets/home/news-right-3-effect.png';
import news_right_4 from '../../assets/home/news-right-4-effect.png';
import news_title from '../../assets/home/news-title.png';
import red_arrow from '../../assets/home/red-arrow.png';
import classroom_img from '../../assets/home/bg.png';
import size_1 from '../../assets/home/size_1.png';
import size_2 from '../../assets/home/size_2.png';
import size_3 from '../../assets/home/size_3.png';

// 导入caipu序列图
import caipu_01 from '../../assets/home/caipu/caipu_01.png';
import caipu_02 from '../../assets/home/caipu/caipu_02.png';
import caipu_03 from '../../assets/home/caipu/caipu_03.png';
import caipu_04 from '../../assets/home/caipu/caipu_04.png';
import caipu_05 from '../../assets/home/caipu/caipu_05.png';
import caipu_06 from '../../assets/home/caipu/caipu_06.png';
import caipu_07 from '../../assets/home/caipu/caipu_07.png';
import caipu_08 from '../../assets/home/caipu/caipu_08.png';
import caipu_09 from '../../assets/home/caipu/caipu_09.png';
import caipu_10 from '../../assets/home/caipu/caipu_10.png';
import caipu_11 from '../../assets/home/caipu/caipu_11.png';
import caipu_12 from '../../assets/home/caipu/caipu_12.png';
import caipu_13 from '../../assets/home/caipu/caipu_13.png';
import caipu_14 from '../../assets/home/caipu/caipu_14.png';
import caipu_15 from '../../assets/home/caipu/caipu_15.png';
import caipu_16 from '../../assets/home/caipu/caipu_16.png';
import caipu_17 from '../../assets/home/caipu/caipu_17.png';
import caipu_18 from '../../assets/home/caipu/caipu_18.png';
import caipu_19 from '../../assets/home/caipu/caipu_19.png';
import caipu_20 from '../../assets/home/caipu/caipu_20.png';
import caipu_21 from '../../assets/home/caipu/caipu_21.png';
import caipu_22 from '../../assets/home/caipu/caipu_22.png';
import caipu_23 from '../../assets/home/caipu/caipu_23.png';
import caipu_24 from '../../assets/home/caipu/caipu_24.png';
import caipu_25 from '../../assets/home/caipu/caipu_25.png';
import caipu_26 from '../../assets/home/caipu/caipu_26.png';
import caipu_27 from '../../assets/home/caipu/caipu_27.png';
import caipu_28 from '../../assets/home/caipu/caipu_28.png';
import caipu_29 from '../../assets/home/caipu/caipu_29.png';
import caipu_30 from '../../assets/home/caipu/caipu_30.png';
import caipu_31 from '../../assets/home/caipu/caipu_31.png';
import caipu_32 from '../../assets/home/caipu/caipu_32.png';
import caipu_33 from '../../assets/home/caipu/caipu_33.png';
import caipu_34 from '../../assets/home/caipu/caipu_34.png';
import caipu_35 from '../../assets/home/caipu/caipu_35.png';
import caipu_36 from '../../assets/home/caipu/caipu_36.png';
import caipu_37 from '../../assets/home/caipu/caipu_37.png';
import caipu_38 from '../../assets/home/caipu/caipu_38.png';
import caipu_39 from '../../assets/home/caipu/caipu_39.png';
import caipu_40 from '../../assets/home/caipu/caipu_40.png';
import caipu_41 from '../../assets/home/caipu/caipu_41.png';
import caipu_42 from '../../assets/home/caipu/caipu_42.png';
import caipu_43 from '../../assets/home/caipu/caipu_43.png';
import caipu_44 from '../../assets/home/caipu/caipu_44.png';
import caipu_45 from '../../assets/home/caipu/caipu_45.png';
import caipu_46 from '../../assets/home/caipu/caipu_46.png';
import caipu_47 from '../../assets/home/caipu/caipu_47.png';
import caipu_48 from '../../assets/home/caipu/caipu_48.png';
import caipu_49 from '../../assets/home/caipu/caipu_49.png';
import caipu_50 from '../../assets/home/caipu/caipu_50.png';
import caipu_51 from '../../assets/home/caipu/caipu_51.png';
import caipu_52 from '../../assets/home/caipu/caipu_52.png';
import caipu_53 from '../../assets/home/caipu/caipu_53.png';
import caipu_54 from '../../assets/home/caipu/caipu_54.png';
import caipu_55 from '../../assets/home/caipu/caipu_55.png';
import caipu_56 from '../../assets/home/caipu/caipu_56.png';
import caipu_57 from '../../assets/home/caipu/caipu_57.png';
import caipu_58 from '../../assets/home/caipu/caipu_58.png';
import caipu_59 from '../../assets/home/caipu/caipu_59.png';
import caipu_60 from '../../assets/home/caipu/caipu_60.png';
import caipu_61 from '../../assets/home/caipu/caipu_61.png';
import caipu_62 from '../../assets/home/caipu/caipu_62.png';
import caipu_63 from '../../assets/home/caipu/caipu_63.png';
import caipu_64 from '../../assets/home/caipu/caipu_64.png';
import caipu_65 from '../../assets/home/caipu/caipu_65.png';
import caipu_66 from '../../assets/home/caipu/caipu_66.png';
import caipu_67 from '../../assets/home/caipu/caipu_67.png';
import caipu_68 from '../../assets/home/caipu/caipu_68.png';
import caipu_69 from '../../assets/home/caipu/caipu_69.png';
import caipu_70 from '../../assets/home/caipu/caipu_70.png';
import caipu_71 from '../../assets/home/caipu/caipu_71.png';
import caipu_72 from '../../assets/home/caipu/caipu_72.png';
import caipu_73 from '../../assets/home/caipu/caipu_73.png';
import caipu_74 from '../../assets/home/caipu/caipu_74.png';
import caipu_75 from '../../assets/home/caipu/caipu_75.png';
import caipu_76 from '../../assets/home/caipu/caipu_76.png';
import caipu_77 from '../../assets/home/caipu/caipu_77.png';
import caipu_78 from '../../assets/home/caipu/caipu_78.png';
import caipu_79 from '../../assets/home/caipu/caipu_79.png';
import caipu_80 from '../../assets/home/caipu/caipu_80.png';
import caipu_81 from '../../assets/home/caipu/caipu_81.png';
import caipu_82 from '../../assets/home/caipu/caipu_82.png';
import caipu_83 from '../../assets/home/caipu/caipu_83.png';
import caipu_84 from '../../assets/home/caipu/caipu_84.png';
import caipu_85 from '../../assets/home/caipu/caipu_85.png';
import caipu_86 from '../../assets/home/caipu/caipu_86.png';
import caipu_87 from '../../assets/home/caipu/caipu_87.png';
import caipu_88 from '../../assets/home/caipu/caipu_88.png';
import caipu_89 from '../../assets/home/caipu/caipu_89.png';
import caipu_90 from '../../assets/home/caipu/caipu_90.png';
import size_4 from '../../assets/home/size_4.png';
import size_4_mobile from '../../assets/home/size_4_mobile.png';
import shipinhao_qr from '../../assets/home/shipinhao.jpg';
import xiaohongshu_qr from '../../assets/home/xiaohongshu.jpg';
import weibo_qr from '../../assets/home/weibo.jpg';
import jiating_weixin_qr from '../../assets/home/jiating_weixin.jpg';
import yewu_weixin_qr from '../../assets/home/yewu_weixin.png';

// about us
import aboutus_bg from '../../assets/home/aboutus_bg.jpg';
import aboutus_bg_mobile from '../../assets/home/aboutus_bg_mobile.jpg';

// social media
import pdd_icon_white from '../../assets/home/pdd-icon-white.png';
import tmall_icon_white from '../../assets/home/tmall-icon-white.png';
import jd_icon_white from '../../assets/home/jd-icon-white.png';
import xhs_icon_white from '../../assets/home/rednote-icon-white.png';
import weibo_icon_white from '../../assets/home/weibo-icon-white.png';
import wechat_icon_white from '../../assets/home/wechat-icon-white.png';
import wechatvideo_icon_white from '../../assets/home/shipinhao-icon-white.png';
import tiktok_icon_white from '../../assets/home/tiktok-icon-white.png';
import sp_slogan from '../../assets/home/sp-slogan.png';


// footer
import footer_topup from '../../assets/home/footer-pagetop.svg';
import footer_chengzhang from '../../assets/home/footer-chengzhang.jpg';

// ============================= mobile assets =============================
import mob_nav from '../../assets/mob_nav.png';
import icon_right1 from '../../assets/icon_right1.png';
import mob_nav_drop from '../../assets/mob_nav-drop.png';
// ============================= mobile assets =============================

// 序列图数组
const caipuImages = [
    caipu_01, caipu_02, caipu_03, caipu_04, caipu_05, caipu_06, caipu_07, caipu_08, caipu_09, caipu_10,
    caipu_11, caipu_12, caipu_13, caipu_14, caipu_15, caipu_16, caipu_17, caipu_18, caipu_19, caipu_20,
    caipu_21, caipu_22, caipu_23, caipu_24, caipu_25, caipu_26, caipu_27, caipu_28, caipu_29, caipu_30,
    caipu_31, caipu_32, caipu_33, caipu_34, caipu_35, caipu_36, caipu_37, caipu_38, caipu_39, caipu_40,
    caipu_41, caipu_42, caipu_43, caipu_44, caipu_45, caipu_46, caipu_47, caipu_48, caipu_49, caipu_50,
    caipu_51, caipu_52, caipu_53, caipu_54, caipu_55, caipu_56, caipu_57, caipu_58, caipu_59, caipu_60,
    caipu_61, caipu_62, caipu_63, caipu_64, caipu_65, caipu_66, caipu_67, caipu_68, caipu_69, caipu_70,
    caipu_71, caipu_72, caipu_73, caipu_74, caipu_75, caipu_76, caipu_77, caipu_78, caipu_79, caipu_80,
    caipu_81, caipu_82, caipu_83, caipu_84, caipu_85, caipu_86, caipu_87, caipu_88, caipu_89, caipu_90
];

/* 右侧菜单 */
const RightMenu = (props) => {
    const [open, setOpen] = useState(false);

    const cli_tiao=(item)=>{
        window.location.href = item.link;
    }
    /**
     * 这里做一下 useState 的index管理，高亮哪一项就行, 默认TOP
     */
    const { devtype } = props;
    if (devtype === 1) { // 移动端
        const menuItems = [
            { title: '首页', link: '/' },
            { title: '产品介绍', link: '/productor' },
            { title: '好侍菜谱', link: '/cookbook' },
            { title: '公司介绍', link: '/index/company/index.html' },
            { title: '业务合作', link: '/index/business/index.html' },
            { title: '联系我们', link: '/index/company/contact.html' }
        ];
        return (
            <div className={`mobile-nav ${open ? 'open' : ''}`}>
                <div className="mobile-nav-bar">
                    <a className={`mobile-logo ${devtype === 1 ? 'mobile' : ''}`} href="/">
                        <img src={logo} alt="House Foods" />
                    </a>
                    <button className="mobile-nav-toggle" onClick={() => setOpen(!open)} aria-expanded={open} aria-label="Toggle navigation">
                        <img src={open ? mob_nav_drop : mob_nav} alt="menu" />
                    </button>
                </div>
                <div className={`mobile-nav-menu ${open ? 'open' : ''}`}>
                    {menuItems.map((item, index) => (

                        <div onClick={() => cli_tiao(item)} className="mobile-nav-menu-child" key={index}>
                            <div className="mobile-nav-item" key={index} href={item.link}>
                                <div className="level-1">
                                    <div className="level-1-left">{item.title}</div>
                                    <div className="level-1-right">
                                        <img src={icon_right1} alt=">" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );
    }
    return (
        <div className={`flex-row justify-between items-center right_menu`}>
            <a className={`item_selected`} href="#top">TOP</a>
            <a className={`menu_text`} href="/productor">商品介绍</a>
            <a className={`menu_text`} href="/cookbook">好侍菜谱</a>
            <a className={`menu_text`} href="/index/company/index.html">关于好侍</a>
            <a className={`menu_text`} href="/index/business/index.html">业务合作</a>
            <a className={`menu_text`} href="/index/company/contact.html">联系我们</a>
        </div>
    );
}

/* 顶部logo */
const LogoHeader = (props) => {
    const { devtype } = props;
    if (devtype === 1) {
        return null;// 移动端不显示，直接在 RightMenu 中显示
    }
    return (
        <div className={`logo_header`}>
            <a href="/"><img src={logo} alt="logo" /></a>
        </div>
    )
}

/* 底部视频 */
const HomeVideo = (props) => {
    const { devtype, onVideoLoad } = props;
    const [videoLoaded, setVideoLoaded] = useState(false);
    const videoRef = useRef(null);

    const handleVideoLoad = () => {
        console.log('视频加载完毕');
        setVideoLoaded(true);
        // iOS 强制静音并尝试播放
        if (videoRef.current) {
            try {
                videoRef.current.muted = true;
                videoRef.current.setAttribute('muted', '');
                const p = videoRef.current.play();
                if (p && typeof p.then === 'function') {
                    p.catch(() => { });
                }
            } catch (e) { }
        }
        onVideoLoad && onVideoLoad(true);
    };

    const handleVideoError = () => {
        console.log('视频加载失败');
        setVideoLoaded(false);
        onVideoLoad && onVideoLoad(false);
    };

    // iOS 自动播放兜底：挂载时和交互时尝试播放
    useEffect(() => {
        const tryPlay = () => {
            if (!videoRef.current) return;
            try {
                videoRef.current.muted = true;
                videoRef.current.setAttribute('muted', '');
                const p = videoRef.current.play();
                if (p && typeof p.then === 'function') {
                    p.catch(() => { });
                }
            } catch (e) { }
        };

        // 首次尝试
        tryPlay();

        // 用户交互兜底
        const onTouch = () => tryPlay();
        document.addEventListener('touchstart', onTouch, { passive: true });
        document.addEventListener('click', onTouch, { passive: true });
        document.addEventListener('visibilitychange', () => {
            if (!document.hidden) tryPlay();
        });

        return () => {
            document.removeEventListener('touchstart', onTouch);
            document.removeEventListener('click', onTouch);
        };
    }, [devtype]);



    if (devtype === 1) {
        const userAgent = navigator.userAgent;
        var is_weichat = 0;
        if(userAgent.indexOf("MicroMessenger") >= 0){
            is_weichat = 1;
        }else{
            is_weichat = 0;
        }

        let w = document.documentElement.clientWidth||document.body.clientWidth;
        // let h = document.documentElement.clientHeight||document.body.clientHeight;
        let video_width = (1920 / 1080) * 525;
        let video_left = (w - video_width) / 2;
        return (
            <div className={`home_video ${devtype === 1 ? 'mobile' : ''}`}>
                {is_weichat === 0
                    ?
                    <div className="home_video_child">
                        <img className="home_video_cover" src={home_video_gif} alt="bannertitle"/>
                    </div>
                    :
                    <div className="home_video_child">
                        <img className="home_video_cover" src={home_video_gif} alt="bannertitle"/>
                    </div>
                }
                <div className={`home_video_text ${devtype === 1 ? 'mobile' : ''}`}>
                    <img src={devtype === 1 ? bannertitle_mobile : bannertitle} alt="bannertitle"/>
                </div>
            </div>
        )
    } else {
        return (
            <div className={`home_video ${devtype === 1 ? 'mobile' : ''}`}>
                <video
                    ref={videoRef}
                    src={home_video}
                    autoPlay
                    loop
                    muted
                    onLoadedData={handleVideoLoad}
                    onError={handleVideoError}
                    style={{display: videoLoaded ? 'block' : 'none'}}
                />

                {/* 默认显示的图片，视频加载后隐藏 */}
                <img
                    className="home_video_img"
                    src={home_video_img}
                    alt="bannertitle"
                    style={{display: videoLoaded ? 'none' : 'block'}}
                />

                {/* 视频正中心显示文字 */}
                <div className={`home_video_text ${devtype === 1 ? 'mobile' : ''}`}>
                    <img src={devtype === 1 ? bannertitle_mobile : bannertitle} alt="bannertitle"/>
                </div>
            </div>

        )
    }

}

/* Banner 轮播 (自定义的 indicator) */
const Banner = (props) => {
    const {devtype, homeData} = props;
    const [currentIndex, setCurrentIndex] = useState(0);
    const swiperRef = React.useRef(null);
    const [isDataReady, setIsDataReady] = useState(false);

    const format = (data) => {
        return data.map((v) => {
            const { image, url, name } = v;
            return {
                url: image,
                desc: name,
                link: url,
            };
        });
    };

    // 使用 useEffect 监听 homeData 变化，确保数据加载完成后再渲染
    useEffect(() => {
        if(homeData && homeData.cv && homeData.cv.item){
            setIsDataReady(true);
        }
    }, [homeData]);

    // 获取格式化后的 slides 数据
    const getSlides = () => {
        const slidesArray = [];
        if(homeData && homeData.cv && homeData.cv.item){
            const cvitem = format(homeData.cv.item);
            for(let i = 0; i < cvitem.length; i++){
                slidesArray.push(cvitem[i]);
            }
        }
        return slidesArray;
    };

    const handleSlideChange = (arg) => {
        // Swiper 会传入实例对象；兜底也支持直接传入索引
        let nextIndex = 0;
        if (typeof arg === 'number') {
            nextIndex = arg;
        } else if (arg && typeof arg === 'object') {
            nextIndex = (typeof arg.realIndex === 'number') ? arg.realIndex
                : (typeof arg.activeIndex === 'number') ? arg.activeIndex
                    : 0;
        }
        setCurrentIndex(nextIndex);
    };

    const handleIndicatorClick = (index) => {
        // console.log('Indicator clicked:', index);
        if (swiperRef.current?.swiper) {
            swiperRef.current.swiper.slideToLoop(index);
        }
    };

    const handleNextClick = () => {
        if (swiperRef.current?.swiper) {
            swiperRef.current.swiper.slideNext();
        }
    };

    const renderIndicators = (devtype) => {
        const slidesData = getSlides();
        return slidesData.map((_, index) => (
            <div
                key={index}
                onClick={() => handleIndicatorClick(index)}
                style={{
                    width: devtype === 1 ? '7px' : '12px',
                    height: devtype === 1 ? '7px' : '12px',
                    borderRadius: '50%',
                    backgroundColor: index === currentIndex ? '#d70013' : '#ffedc0',
                    cursor: 'pointer',
                    margin: '0 8px',
                    transition: 'all 0.3s ease'
                }}
            />
        ));
    };

    // 如果数据未加载完成，不显示banner
    if (!isDataReady) {
        return null;
    }

    const slidesData = getSlides();

    return (
        <div className={`banner ${devtype === 1 ? 'mobile' : ''}`}>
            <HsSwiper
                ref={swiperRef}
                slides={slidesData}
                slidesPerView={devtype === 1 ? 1 : 3}
                spaceBetween={devtype === 1 ? 20 : 30}
                loop={true}
                centerScale={true}
                autoplay={{
                    delay: 3000,
                    disableOnInteraction: false
                }}
                onSlideChange={handleSlideChange}
                initialSlide={0}
            />
            <div className="banner-indicator">
                {renderIndicators(devtype)}
                <div
                    className="banner-next"
                    onClick={handleNextClick}
                    style={{ cursor: 'pointer' }}
                />
            </div>
        </div>
    );
}

/* 日式咖喱课堂 */
const Classroom = (props) => {
    const { devtype } = props;
    const [, setIsVisible] = useState(false);
    const sectionRef = React.useRef(null);
    const [classNewMove, setClassNewMove] = useState('');

    React.useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                // 当元素进入视口超过50%时触发动画
                if (entry.intersectionRatio >= 0.5) {
                    setIsVisible(true);
                    observer.disconnect();
                }
            },
            {
                threshold: [0, 0.5], // 监听0%和50%两个阈值
                rootMargin: '-100px 0px' // 视口向内缩小100px，确保元素充分进入视口
            }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => observer.disconnect();
    }, []);

    const renderMobile = () => {
        return null;
    }

    const renderPC = () => {
        return (

                <div className="div_center_img">
                    <VisibilityObserver effect="fade-up" threshold={0.3} duration={1000} delay={100} onEnded={() => {
                        setClassNewMove('class_img_new_move');
                    }}>
                    <div className={`div_since1963 ${classNewMove}`}>
                        <img src={since1963} className="img_since1963" alt="since1963" />
                    </div>
                    <div className="div_tomatosoup">
                        <img src={tomatosoup} className="img_tomatosoup" alt="tomatosoup" />
                    </div>
                    <div className="div_oyako">
                        <img src={oyako} className="img_oyako" alt="oyako" />
                    </div>
                    <div className={`div_spice ${classNewMove}`}>
                        <img src={spice} className="img_spice" alt="spice" />
                    </div>
                    <div className={`div_spoon ${classNewMove}`}>
                        <img src={spoon} className="img_spoon" alt="spoon" />
                    </div>
                    <div className={`div_curryill ${classNewMove}`}>
                        <img src={curryill} className="img_curryill" alt="curryill" />
                    </div>
                    <div className={`div_since_left_bottom ${classNewMove}`}>
                        <img src={since_left_bottom} className="img_since_left_bottom" alt="since_left_bottom" />
                    </div>
                    <div className="div_currydish01">
                        <img src={currydish01} className="img_currydish01" alt="currydish01" />
                    </div>
                    <div className="div_dah">
                        <img src={dah} className="img_dah" alt="dah" />
                    </div>
                    <img src={classroom_img} className="classBg" alt="classroom_img" />
                    </VisibilityObserver>
                </div>

        )
    }

    return (
        <div className={`classroom ${devtype === 1 ? 'mobile' : ''}`}>

            {devtype === 1 ? (
                <div className="mobile-classroom-top">
                    {/* since 1963 */}

                    <div className="div_since1963 mobile">
                        <VisibilityObserver effect="fade-up" threshold={0.3} duration={1000} delay={100}>
                        <img src={since1963} className="img_since1963" alt="since1963"/>
                        </VisibilityObserver>
                    </div>


                    {/* spoon */}
                    <div className="div_spoon mobile">
                        <VisibilityObserver effect="fade-up" threshold={0.3} duration={1000} delay={100}>
                        <img src={spoon} className="img_spoon" alt="spoon"/>
                        </VisibilityObserver>
                    </div>

                    {/* curryill */}
                    <div className="div_curryill mobile">
                        <VisibilityObserver effect="fade-up" threshold={0.3} duration={1000} delay={100}>
                        <img src={curryill} className="img_curryill" alt="curryill"/>
                        </VisibilityObserver>
                    </div>
                </div>
            ) : null}

            {devtype === 1 ? renderMobile() : renderPC()}

            <div className={`classroom-content-child ${devtype === 1 ? 'mobile' : ''}`}>
                <div className="classroom-center">

                    <VisibilityObserver effect="fade-up" threshold={0.3} duration={1000} delay={100}>
                        <div className="center-logo">
                            <img src={housecurry} alt="House Curry"
                                 className={`housecurry ${devtype === 1 ? 'mobile' : ''}`}/>
                        </div>
                    </VisibilityObserver>

                    <VisibilityObserver effect="fade-up" threshold={0.3} duration={1000} delay={100}>
                        <div className={`slogan ${devtype === 1 ? 'mobile' : ''}`}>
                            {devtype === 1 ? <img src={sp_slogan} alt="不止于味，更在于心。"/> :
                                <img src={size_1} alt="不止于味，更在于心。"/>}
                        </div>
                    </VisibilityObserver>

                    <VisibilityObserver effect="fade-up" threshold={0.3} duration={1000} delay={100}>
                        <div className={`description ${devtype === 1 ? 'mobile' : ''}`}>
                            <p>好侍咖喱源自1926年，</p>
                            <p>专注于更健康，更美味，更便利</p>
                            <p>时刻陪伴千家万户。</p>
                            <p>我们愿与您一起</p>
                            <p>探索咖喱的无限可能，</p>
                            <p>让餐桌常伴幸福与温馨。</p>
                        </div>
                    </VisibilityObserver>

                    <VisibilityObserver effect="fade-up" threshold={0.3} duration={1000} delay={100}>
                        <div className={`classroom-link ${devtype === 1 ? 'mobile' : ''}`}>
                            <a href="/index/curry/index">
                                <img src={red_arrow} alt="日式咖喱课堂"
                                     className={`japn_curry_clsname ${devtype === 1 ? 'mobile' : ''}`}/>
                            </a>
                        </div>
                    </VisibilityObserver>
                </div>
            </div>

            {devtype === 1 ? (
                <div className="mobile-classroom-bottom">
                    {/*<div className="div_currydish01 mobile">*/}
                    {/*    <img src={currydish01} className="img_currydish01" alt="currydish01" />*/}
                    {/*</div>*/}
                    {/*<div className="div_dah mobile">*/}
                    {/*    <img src={dah_mobile} className="img_dah mobile" alt="dah" />*/}
                    {/*</div>*/}
                </div>
            ) : null}
        </div>
    )
}

// 全部菜谱
const AllCookbook = (props) => {
    const {devtype, currentCaipuIndex, onVisibilityObserverEnded} = props;
    const swiperRef = useRef(null);
    const cookbookRef = useRef(null);

    useEffect(() => {
        if (devtype === 1) {
            return;
        }
        const observer = new IntersectionObserver(
            ([entry]) => {
                const links = document.querySelector('.cookbook-links');
                if (!links) return;
                if (entry.intersectionRatio >= 0.05) {
                    links.classList.add('visible');
                } else {
                    links.classList.remove('visible');
                }
            },
            {
                threshold: [0, 0.1, 0.5, 0.8, 1]
            }
        );

        // 以 .cookbook-links 自身作为可见性依据（不再依赖 .all-cookbook）
        const linksEl = document.querySelector('.cookbook-links');
        if (linksEl) {
            observer.observe(linksEl);
        }

        // 粘性定位：让 .link-all 在 .cookbook-links 内部浮动
        const handleCookbookScroll = () => {
            const cookbookLinks = document.querySelector('.cookbook-links');
            if (!cookbookLinks) return;
            const linkAll = cookbookLinks.querySelector('.link-all');
            if (!linkAll) return;

            // 以 .cookbook-links 自身作为边界容器
            const containerRect = cookbookLinks.getBoundingClientRect();
            const linkRect = linkAll.getBoundingClientRect();
            const linkH = Math.max(linkRect.height || 0, linkAll.offsetHeight || 0, linkAll.scrollHeight || 0);

            const fixedTop = 0; // 与样式匹配
            const canStick = containerRect.height > linkH + fixedTop;

            // 容器内粘性区间
            if (canStick && containerRect.top <= fixedTop && containerRect.bottom >= fixedTop + linkH) {
                // 固定在视口，横向对齐容器左侧，宽度锁定避免跳动
                linkAll.style.position = 'fixed';
                linkAll.style.top = fixedTop + 'px';
                linkAll.style.left = containerRect.left + 'px';
                linkAll.style.width = containerRect.width + 'px';
                linkAll.style.bottom = 'auto';
            } else {
                // 回到容器内：顶部或底部跟随
                linkAll.style.position = 'absolute';
                linkAll.style.left = '0px';
                linkAll.style.width = '';

                if (containerRect.top > fixedTop) {
                    // 贴容器顶（与 fixedTop 对齐，避免切换跳动）
                    linkAll.style.top = fixedTop + 'px';
                    linkAll.style.bottom = 'auto';
                } else {
                    // 贴容器底
                    linkAll.style.top = 'auto';
                    linkAll.style.bottom = '0px';
                }
            }
        };

        handleCookbookScroll();
        window.addEventListener('scroll', handleCookbookScroll);
        window.addEventListener('resize', handleCookbookScroll);
        window.addEventListener('load', handleCookbookScroll);

        return () => {
            observer.disconnect();
            window.removeEventListener('scroll', handleCookbookScroll);
            window.removeEventListener('resize', handleCookbookScroll);
            window.removeEventListener('load', handleCookbookScroll);
        };
    }, [devtype]);

    const cli_foods_one = () => {
        window.location.href = "/bmd/";
    }
    const cli_foods_two = () => {
        window.location.href = "/index/xingwbasiccooking";
    }

    const bannerItems = [
        {
            brand: '百梦多',
            title: '鸡肉咖喱饭',
            description_one: '添加浓缩苹果浆和蜂蜜，',
            description_two: '口味柔和的咖喱产品',
            logo: bmdlogo2x,
            package: bmd_package,
            image: all_foods_banner,
            link: '/bmd/',
        },
        {
            brand: '咖王',
            title: '牛肉咖喱蛋包饭',
            description_one: '醇厚浓郁的纯正日式咖喱，',
            description_two: '在家享受餐厅级般口味',
            logo: gwlogo2x,
            package: gw_package,
            image: all_foods_banner_2,
            link: '/index/xingwbasiccooking',
        },
        {
            brand: '百梦多',
            title: '鸡肉咖喱饭',
            description_one: '添加浓缩苹果浆和蜂蜜，',
            description_two: '口味柔和的咖喱产品',
            logo: bmdlogo2x,
            package: bmd_package,
            image: all_foods_banner,
            link: '/bmd/',
        },
        {
            brand: '咖王',
            title: '牛肉咖喱蛋包饭',
            description_one: '醇厚浓郁的纯正日式咖喱，',
            description_two: '在家享受餐厅级般口味',
            logo: gwlogo2x,
            package: gw_package,
            image: all_foods_banner_2,
            link: '/index/xingwbasiccooking',
        },
        {
            brand: '百梦多',
            title: '鸡肉咖喱饭',
            description_one: '添加浓缩苹果浆和蜂蜜，',
            description_two: '口味柔和的咖喱产品',
            logo: bmdlogo2x,
            package: bmd_package,
            image: all_foods_banner,
            link: '/bmd/',
        },
        {
            brand: '咖王',
            title: '牛肉咖喱蛋包饭',
            description_one: '醇厚浓郁的纯正日式咖喱，',
            description_two: '在家享受餐厅级般口味',
            logo: gwlogo2x,
            package: gw_package,
            image: all_foods_banner_2,
            link: '/index/xingwbasiccooking',
        },


    ];

    // 移动端
    const renderMobileAllCookbookContent = () => {
        return (
            <div className="all-cookbook-mobile-content">
                <div className="all-cookbook-mobile-content-item" >
                    <img onClick={() => cli_foods_one()} src={all_foods_banner} className="all_foods_banner" alt="all_foods_banner" />
                    <div className="bmd_package_c">
                        <img onClick={() => cli_foods_one()} src={bmd_package_mobile} className="bmd_package" alt="bmd_package" />
                    </div>
                    <div className="center-content">
                        <img src={size_mobile_1} className="bmdlogo1x" alt="bmdlogo2x" />
                        <div className="bmd-title">鸡肉咖喱饭</div>
                        <div className="moble-chopstick-container-2">
                            <img src={two_line} alt="chopstick-2" className="moble-chopstick"/>
                        </div>
                    </div>
                    <div className="bmd-description">添加浓缩苹果浆和蜂蜜，<br />口味柔和的咖喱产品</div>
                    <div className="bmd-button">
                        <img onClick={() => cli_foods_one()} src={button_see} alt="button_see" />
                    </div>
                </div>

                <div className="all-cookbook-mobile-content-item" >
                    <img onClick={() => cli_foods_two()} src={all_foods_banner_2} className="all_foods_banner" alt="all_foods_banner" />
                    <div className="bmd_package_c">
                        <img onClick={() => cli_foods_two()} src={bmd_package_2_mobile} className="bmd_package" alt="bmd_package" />
                    </div>
                    <div className="center-content">
                        <img src={size_mobile_2} className="bmdlogo2x" alt="bmdlogo2x" />
                        <div className="bmd-title">牛肉咖喱蛋包饭</div>
                        <div className="moble-chopstick-container-2">
                            <img src={two_line} alt="chopstick-2" className="moble-chopstick" />
                        </div>
                    </div>
                    <div className="bmd-description">醇厚浓郁的日式咖喱，<br />在家享受餐厅级般口味</div>
                    <div className="bmd-button">
                        <img onClick={() => cli_foods_two()} src={button_see} alt="button_see" />
                    </div>
                </div>
            </div>
        )
    }
    // allmenu
    return (
        <div className={`all-cookbook ${devtype === 1 ? 'mobile' : ''}`} ref={cookbookRef}>

            <div className={`cookbook-links ${devtype === 1 ? 'mobile' : ''} ${devtype === 2 ? 'pad' : ''}`}>
                <a href="/cookbook" className="link-all">
                    <img src={left_arrow_1} className="allmenu" alt="全部菜谱" />
                </a>
            </div>

            <div className="cookbook-content">
                <div className={`white-content ${devtype === 1 ? 'mobile' : ''}`}>
                    <div className={`cookbook-title ${devtype === 1 ? 'mobile' : ''}`}>
                        <VisibilityObserver effect="fade-up" threshold={0.3} duration={1000} delay={100}>
                            <img src={recipetitle} alt="House Recipe" className={`title-image ${devtype === 1 ? 'mobile' : ''}`} />
                        </VisibilityObserver>
                        <VisibilityObserver effect="fade-up" threshold={0.3} duration={1000} delay={100} onEnded={() => {
                            //回调之后播放序列图
                            if (onVisibilityObserverEnded) {
                                onVisibilityObserverEnded();
                            }
                        }}>
                        <div className={`title-text ${devtype === 1 ? 'mobile' : ''}`}>
                            {caipuImages.map((image, index) => (
                                <img 
                                    key={index} 
                                    src={image} 
                                    alt="招牌菜谱" 
                                    style={{ display: index === currentCaipuIndex ? 'unset' : 'none' }}
                                />
                            ))}
                        </div>
                        </VisibilityObserver>
                        <VisibilityObserver effect="fade-up" threshold={0.3} duration={1000} delay={100}>
                        {devtype === 1 ? <p className="title-desc mobile">从经典日式咖喱到创新料理<br />好侍帮助您简单解锁更多可能<br />打造让家人充满期待的餐桌</p>
                            : <p className="title-desc">从经典日式咖喱到创新料理<br />好侍精心研发简单易操作的菜谱<br />打造美满幸福的餐桌</p>}
                        </VisibilityObserver>
                    </div>

                    {/* allcookbook 内容 */}
                    <VisibilityObserver effect="fade-up" threshold={0.3} duration={1000} delay={100}>
                    {devtype === 1 ? renderMobileAllCookbookContent() : <div className="recipe-banner">
                        <div className="banner-prev" onClick={() => swiperRef.current?.swiper.slideNext()}>
                            <img src={menubutton_icon_red} alt="Previous" style={{ transform: 'rotate(180deg)' }} />
                        </div>
                        <div className="banner-next" onClick={() => swiperRef.current?.swiper.slidePrev()}>
                            <img src={menubutton_icon_red} alt="Next" />
                        </div>
                        <HsSwiper
                            ref={swiperRef}
                            slidesPerView={2}
                            //spaceBetween={40}
                            loop={true}
                            // autoplay={{
                            //     delay: 3000,
                            //     disableOnInteraction: false
                            // }}
                            slides={bannerItems.map((item) => ({
                                url: '#',
                                link: item.link,
                                content: (
                                    <div className="banner-item">
                                        <div className="item-left">
                                            <img src={item.logo} alt={item.brand} className="brand-logo" />
                                            <div className="item-info">
                                                <h3 className={`item-title ${devtype === 1 ? 'mobile' : ''}`}>{item.title}</h3>
                                                <p className={`item-desc ${devtype === 1 ? 'mobile' : ''}`}>{item.description_one}<br />{item.description_two}</p>
                                            </div>
                                            <img src={item.package} alt={`${item.brand}包装`}
                                                className="brand-package" />
                                        </div>
                                        <div className="item-center"></div>
                                        <div className="item-right">
                                            <img src={talk_fukidashi_1} alt="chopstick 1" className="chopstick-1" />
                                            <img src={talk_fukidashi_2} alt="chopstick 2" className="chopstick-2" />
                                            <div className="food-k">
                                                <img src={item.image} alt={item.title} className="food-image"/>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }))}
                        />
                    </div>}
                    </VisibilityObserver>



                </div>
            </div>
        </div>
    )
}

// 全部食材
const AllFoods = (props) => {
    const { devtype } = props;
    // 4个图片
    const foodImagesBottom = [all_foods_1_bottom, all_foods_2_bottom, all_foods_3_bottom, all_foods_4_bottom];
    const foodImagesTop = [all_foods_1_top, all_foods_2_top, all_foods_3_top, all_foods_4_top];

    const cli_link = () => {
        window.location.href = "/cookbook";
    };

    const renderMobileAllFoodsContent = (imgaes, scrollDirection) => {
        return (
            <VisibilityObserver effect="fade-up" threshold={0.3} duration={1000} delay={100}>
                <div className={`all-foods ${devtype === 1 ? 'mobile' : ''}`}>
                    <div className="infinite-scroll-container">
                        <div className={`infinite-scroll-wrapper ${scrollDirection}`}>
                            {[...imgaes, ...imgaes, ...imgaes, ...imgaes, ...imgaes, ...imgaes, ...imgaes, ...imgaes, ...imgaes].map((image, index) => (
                                <div key={index} className={`food-item food-item-${(index % 4) + 1} ${devtype === 1 ? 'mobile' : ''}`}>
                                    <img src={image} className={`food-item-img ${devtype === 1 ? 'mobile' : ''}`} alt={`好侍美食 ${(index % 4) + 1}`} />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </VisibilityObserver>
        )
    }

    return (

        <div onClick={() => cli_link()} className={`all-foods-container ${devtype === 1 ? 'mobile' : ''}`}>
            <VisibilityObserver effect="fade-up" threshold={0.3} duration={1000} delay={100}>
            {renderMobileAllFoodsContent(foodImagesBottom, 'scroll-left')}
            {renderMobileAllFoodsContent(foodImagesTop, 'scroll-right')}
            </VisibilityObserver>
            <VisibilityObserver effect="fade-up" threshold={0.3} duration={1000} delay={100}>
            {devtype === 1 ? <div className={`all-foods-links ${devtype === 1 ? 'mobile' : ''}`}>
                    <a href="/cookbook" className="link-all">
                        <img src={arrow_mobile_1} className="allmenu" alt="全部菜谱" />
                    </a>
                </div> : null}
            </VisibilityObserver>

        </div>

    )
}

// 商品介绍
const ProductIntro = (props) => {
    const { devtype } = props;
    const [currentIndex, setCurrentIndex] = useState(0);
    const [swiperEnabled, setSwiperEnabled] = useState(false);
    const swiperRef = React.useRef(null);
    const productRef = React.useRef(null);

    React.useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (devtype === 1)
                    return;

                const links = document.querySelector('.product-links');
                if (!links) return;

                // 按 20% 可见度切换出现/隐藏
                if (entry.intersectionRatio >= 0.2) {
                    links.classList.add('visible');
                } else {
                    links.classList.remove('visible');
                }
            },
            {
                root: null,
                threshold: [0, 0.2, 0.5, 0.8, 1]
            }
        );

        if (productRef.current) {
            observer.observe(productRef.current);
        }

        // 添加滚动监听，实现粘性定位效果（限制在 .product 容器内）
        const handleScroll = () => {
            const productElement = productRef.current;
            const linksElement = document.querySelector('.product-links');

            if (!productElement || !linksElement) return;

            const productRect = productElement.getBoundingClientRect();
            const linksRect = linksElement.getBoundingClientRect();
            const linksHeight = Math.max(linksRect.height || 0, linksElement.offsetHeight || 0, linksElement.scrollHeight || 0);

            const productTop = productRect.top;       // 容器顶到视口顶距离
            const productBottom = productRect.bottom; // 容器底到视口顶距离

            // 链接块期望的固定顶部偏移
            const fixedTopPx = 90;

            // 判断容器是否足够高，避免抖动
            const canStick = (productRect.height > linksHeight + fixedTopPx);

            // 在容器内滚动区间：当容器顶 <= 固定top，且 容器底 >= 固定top + 链接块高
            if (canStick && productTop <= fixedTopPx && productBottom >= fixedTopPx + linksHeight) {
                // 固定在视口内
                linksElement.style.position = 'fixed';
                linksElement.classList.add('sticky');
                // 防止残留
                linksElement.style.bottom = 'auto';
            } else {
                // 回到容器内的绝对定位，分别贴近容器顶或底
                linksElement.style.position = 'absolute';
                linksElement.classList.remove('sticky');

                if (productTop > fixedTopPx) {
                    // 还没滚到粘性点：贴近容器顶，保持与容器一起滑动
                    linksElement.style.top = fixedTopPx + 'px';
                    linksElement.style.bottom = 'auto';
                } else {
                    // 超过容器底：贴近容器底
                    linksElement.style.top = 'auto';
                    linksElement.style.bottom = '10%';
                    // 到达容器底部时隐藏（左滑消失）
                    const linksNearBottom = productBottom <= (fixedTopPx + linksHeight + 1);
                    if (linksNearBottom) {
                        linksElement.classList.remove('visible');
                    }
                }
            }
        };

        // 初始调用一次
        handleScroll();

        window.addEventListener('scroll', handleScroll);
        window.addEventListener('resize', handleScroll);
        window.addEventListener('load', handleScroll);

        return () => {
            observer.disconnect();
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('resize', handleScroll);
            window.removeEventListener('load', handleScroll);
        };
    }, [devtype]);

    // 监控 autoplay 状态，确保长时间运行后仍能正常工作
    React.useEffect(() => {
        const checkAutoplay = () => {
            if (swiperRef.current?.swiper) {
                const swiper = swiperRef.current.swiper;
                if (swiper.autoplay && !swiper.autoplay.running) {
                    console.log('Restarting autoplay...');
                    swiper.autoplay.start();
                }
            }
        };

        // 每10秒检查一次 autoplay 状态
        const interval = setInterval(checkAutoplay, 10000);

        return () => {
            clearInterval(interval);
        };
    }, []);

    const products_pc = [
        {
            title: '咖喱调料类',
            subtitle: '家庭用',
            image: sku_bmd_gw,
            background: {
                light: '#fff1c4',
                dark: '#603200'
            },
            href: '/productor?type=0#section-0',
        },
        {
            title: '软罐头食品',
            subtitle: '家庭用',
            image: sku_wdd,
            background: {
                light: '#fff1c4',
                dark: '#efbc3a'
            },
            href: '/productor?type=0#section-1',
        },
        {
            title: '西餐调料类',
            subtitle: '家庭用',
            image: sku_xq_fq,
            background: {
                light: '#fff1c4',
                dark: '#e88931'
            },
            href: '/productor?type=0#section-2',
        },
        {
            title: '业务用商品',
            subtitle: '',
            image: sku_business,
            background: {
                light: '#fff1c4',
                dark: '#6ea06e'
            },
            href: '/productor?type=1',
        },
        {
            title: '咖喱调料类',
            subtitle: '家庭用',
            image: sku_bmd_gw,
            background: {
                light: '#fff1c4',
                dark: '#603200'
            },
            href: '/productor?type=0#section-0',
        },
        {
            title: '软罐头食品',
            subtitle: '家庭用',
            image: sku_wdd,
            background: {
                light: '#fff1c4',
                dark: '#efbc3a'
            },
            href: '/productor?type=0#section-1',
        },
        {
            title: '西餐调料类',
            subtitle: '家庭用',
            image: sku_xq_fq,
            background: {
                light: '#fff1c4',
                dark: '#e88931'
            },
            href: '/productor?type=0#section-2',
        },
        {
            title: '业务用商品',
            subtitle: '',
            image: sku_business,
            background: {
                light: '#fff1c4',
                dark: '#6ea06e'
            },
            href: '/productor?type=1',
        },
    ];




    const products_wap = [
        {
            title: '咖喱调料类',
            subtitle: '家庭用',
            image: sku_bmd_gw,
            background: {
                light: '#fff1c4',
                dark: '#603200'
            },
            href: '/productor?type=0#section-0',
        },
        {
            title: '软罐头食品',
            subtitle: '家庭用',
            image: sku_wdd,
            background: {
                light: '#fff1c4',
                dark: '#efbc3a'
            },
            href: '/productor?type=0#section-1',
        },
        {
            title: '西餐调料类',
            subtitle: '家庭用',
            image: sku_xq_fq,
            background: {
                light: '#fff1c4',
                dark: '#e88931'
            },
            href: '/productor?type=0#section-2',
        },
        {
            title: '业务用商品',
            subtitle: '',
            image: sku_business,
            background: {
                light: '#fff1c4',
                dark: '#6ea06e'
            },
            href: '/productor?type=1',
        },
        {
            title: '咖喱调料类',
            subtitle: '家庭用',
            image: sku_bmd_gw,
            background: {
                light: '#fff1c4',
                dark: '#603200'
            },
            href: '/productor?type=0#section-0',
        },
        {
            title: '软罐头食品',
            subtitle: '家庭用',
            image: sku_wdd,
            background: {
                light: '#fff1c4',
                dark: '#efbc3a'
            },
            href: '/productor?type=0#section-1',
        },
        {
            title: '西餐调料类',
            subtitle: '家庭用',
            image: sku_xq_fq,
            background: {
                light: '#fff1c4',
                dark: '#e88931'
            },
            href: '/productor?type=0#section-2',
        },
        {
            title: '业务用商品',
            subtitle: '',
            image: sku_business,
            background: {
                light: '#fff1c4',
                dark: '#6ea06e'
            },
            href: '/productor?type=1',
        },
    ];
    const products = devtype == 1 ? products_wap : products_pc;
    const slides = products.map(product => ({
        content: (
            <div
                onClick={() => cli_product(product)}
                className={`product-item ${devtype === 1 ? 'mobile' : ''}`}
                style={{
                    background: `linear-gradient(to bottom, ${product.background.light} 47%, ${product.background.dark} 0%)`
                }}
            >
                <div className="item-info">
                    <div className={`title ${devtype === 1 ? 'mobile' : ''}`}>{product.title}</div>
                    <div className={`subtitle ${devtype === 1 ? 'mobile' : ''}`}>{product.subtitle}</div>
                </div>
                <div className="item-image">
                    <img src={product.image} alt={product.title} />
                </div>
            </div>
        )
    }));

    const handleSlideChange = (arg) => {
        let nextIndex = 0;
        if (typeof arg === 'number') {
            nextIndex = arg;
        } else if (arg && typeof arg === 'object') {
            // 在loop模式下，优先使用realIndex，因为它更准确
            if (typeof arg.realIndex === 'number') {
                nextIndex = arg.realIndex;
            } else if (typeof arg.activeIndex === 'number') {
                nextIndex = arg.activeIndex;
            } else {
                nextIndex = 0;
            }
        }
        // 直接使用索引，因为现在显示8个指示器
        setCurrentIndex(nextIndex);
    };

    const handleIndicatorClick = (index) => {
        if (swiperRef.current?.swiper) {
            swiperRef.current.swiper.slideToLoop(index);
        }
    };
    const cli_product = (product) => {
        window.location.href = product.href;
    };

    const handlePrevClick = () => {
        if (swiperRef.current?.swiper) {
            swiperRef.current.swiper.slidePrev();
        }
    };

    const handleNextClick = () => {
        if (swiperRef.current?.swiper) {
            swiperRef.current.swiper.slideNext();
        }
    };

    const renderIndicators = (devtype) => {
        // 只显示前4个产品的指示器，因为后4个是重复的
        // const uniqueProducts = products.slice(0, 4);
        return products.map((_, index) => (
            <div
                key={index}
                onClick={() => handleIndicatorClick(index)}
                style={{
                    width: devtype === 1 ? '7px' : '12px',
                    height: devtype === 1 ? '7px' : '12px',
                    borderRadius: '50%',
                    backgroundColor: index === currentIndex ? '#d70013' : '#ffedc0',
                    cursor: 'pointer',
                    margin: '0 8px',
                    transition: 'all 0.3s ease'
                }}
            />
        ));
    };

    return (
        <div className={`product ${devtype === 1 ? 'mobile' : ''}`} ref={productRef}>
            <div className={`product-links ${devtype === 1 ? 'mobile' : ''}`}>
                <a href="/productor" className="link-home">
                    <img src={left_arrow_2} className="home-sku-link" alt="家庭用商品一览" />
                </a>
                <a href="/productor?type=1" className="link-business">
                    <img src={left_arrow_3} className="business-sku-link" alt="业务用商品一览" />
                </a>
            </div>
            <div className="product-content">
                <div className={`product-title ${devtype === 1 ? 'mobile' : ''}`}>
                    <VisibilityObserver effect="fade-up" threshold={0.3} duration={1000} delay={100}>
                    <img src={lineuptitle} alt="Line up" className={`lineuptitle ${devtype === 1 ? 'mobile' : ''}`} />
                    </VisibilityObserver>
                    <VisibilityObserver effect="fade-up" threshold={0.3} duration={1000} delay={100}>
                    <div className={`cn-title ${devtype === 1 ? 'mobile' : ''}`}>
                        <img src={size_3} alt="商品介绍" />
                    </div>
                    </VisibilityObserver>
                </div>
                <VisibilityObserver effect="fade-up" threshold={0.3} duration={1000} delay={100} onEnded={() => {
                    //回调之后执行swiper
                    setSwiperEnabled(true);
                }}>
                    <div className={`product-list ${devtype === 1 ? 'mobile' : ''}`}>
                        <Swiper
                            ref={swiperRef}
                            modules={[Autoplay, Navigation]}
                            slidesPerView={devtype === 1 ? 'auto' : 4}
                            spaceBetween={20}
                            centeredSlides={devtype === 1 ? true : false}
                            loop={true}
                            loopAdditionalSlides={2}
                            autoplay={swiperEnabled ? {
                                delay: 3000,
                                disableOnInteraction: false,
                                pauseOnMouseEnter: false
                            } : false}
                            onSlideChange={handleSlideChange}
                            initialSlide={0}
                            speed={800}
                        >
                            {slides.map((slide, index) => (
                                <SwiperSlide key={index} className={`slideItem ${devtype === 1 ? 'mobile' : ''}`}>
                                    {slide.content}
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                    <div className="product-indicator">
                        <div className="arrow_left" onClick={handlePrevClick}/>
                        <div className="dots">
                            {renderIndicators(devtype)}
                        </div>
                        <div className="arrow_right" onClick={handleNextClick}/>
                    </div>
                </VisibilityObserver>
            </div>

            {devtype === 1 &&
                <VisibilityObserver effect="fade-up" threshold={0.3} duration={1000} delay={100}>
                <div className="family-produc-links-container">

                <div className={`family-produc-links-family ${devtype === 1 ? 'mobile' : ''}`}>
                    <a href="/productor" className="link-all">
                        <img src={arrow_mobile_2} className="allmenu" alt="家庭用商品一览" />
                    </a>
                </div>

                <div className={`family-produc-links-business ${devtype === 1 ? 'mobile' : ''}`}>
                    <a href="/productor#section-2" className="link-all">
                        <img src={arrow_mobile_3} className="allmenu" alt="业务用商品一览" />
                    </a>
                </div>

            </div>
                </VisibilityObserver>
            }
        </div>
    )
}

// 了解好侍
const AboutHs = (props) => {
    const { devtype } = props;
    return (
        <VisibilityObserver effect="fade-up" threshold={0.3} duration={1000} delay={100}>
        <div className={`about-hs ${devtype === 1 ? 'mobile' : ''}`}>
            <div className={`about-content ${devtype === 1 ? 'mobile' : ''}`}>
                <div className={`about-left ${devtype === 1 ? 'mobile' : ''}`}>
                    <div className={`about-title ${devtype === 1 ? 'mobile' : ''}`}>
                        <VisibilityObserver effect="fade-up" threshold={0.3} duration={1000} delay={400}>
                        <img src={abouths_title} alt="About House" />
                        </VisibilityObserver>
                        <VisibilityObserver effect="fade-up" threshold={0.3} duration={1000} delay={400}>
                        <div className={`about-title-text ${devtype === 1 ? 'mobile' : ''}`}>了解好侍</div>
                        </VisibilityObserver>
                    </div>
                    <div className={`about-links ${devtype === 1 ? 'mobile' : ''}`}>
                        <VisibilityObserver effect="fade-up" threshold={0.3} duration={1000} delay={400}>
                        <a href="/index/company/history.html" className={`link-item ${devtype === 1 ? 'mobile' : ''}`}>
                            <span>好侍沿革</span>
                            <img src={arrow} className="arrow" alt="arrow" />
                        </a>
                        </VisibilityObserver>
                        <VisibilityObserver effect="fade-up" threshold={0.3} duration={1000} delay={400}>
                        <a href="/index/company/purpose.html" className={`link-item ${devtype === 1 ? 'mobile' : ''}`}>
                            <span>集团理念</span>
                            <img src={arrow} className="arrow" alt="arrow" />
                        </a>
                        </VisibilityObserver>
                        <VisibilityObserver effect="fade-up" threshold={0.3} duration={1000} delay={400}>
                        <a href="/index/company/network.html" className={`link-item ${devtype === 1 ? 'mobile' : ''}`}>
                            <span>市场营销网络</span>
                            <img src={arrow} className="arrow" alt="arrow" />
                        </a>
                        </VisibilityObserver>
                    </div>
                </div>
                <div className={`about-right ${devtype === 1 ? 'mobile' : ''}`}>
                    <img src={devtype === 1 ? abouths_mobile : abouths} alt="abouths"/>
                </div>
            </div>
        </div>
        </VisibilityObserver>
    )
}

// 新闻中心
const News = (props) => {
    const { devtype, homeData } = props;
    const [newsData, setNewsData] = useState([]);
    const [classNewMove, setClassNewMove] = useState('');
    const newsOptions = {
        2: "公司",
        1: "产品",
        3: "活动",
    }

    useEffect(() => {
        if (homeData && homeData.news && homeData.news.item){
            const HomeNewsData = homeData.news.item;
            const newsListData = [];
            console.log(HomeNewsData);
            for(let i = 0; i < HomeNewsData.length; i++){
                newsListData.push(HomeNewsData[i]);
            }
            setNewsData(newsListData);
        }
    }, [homeData]);

    const cli_newDetail = (news_id) => {
        window.location.href = "/newsdetail/"+news_id;

    }


    return (
        <VisibilityObserver effect="fade-up" threshold={0.3} duration={1000} delay={100} onEnded={() => {
            setClassNewMove('class_img_new_move');
        }}>
        <div className={`news ${devtype === 1 ? 'mobile' : ''}`}>

            <img src={devtype === 1 ? news_left_6 : news_left_1} className={`news-left-1 ${devtype === 1 ? 'mobile' : ''}`} alt="news-left-1" />

            <img src={news_left_2} className={`news-left-2 ${devtype === 1 ? 'mobile' : ''} ${classNewMove}`} alt="news-left-2" />
            <img src={news_left_3} className={`news-left-3 ${devtype === 1 ? 'mobile' : ''} ${classNewMove}`} alt="news-left-3" />
            <img src={news_left_4} className={`news-left-4 ${devtype === 1 ? 'mobile' : ''} ${classNewMove}`} alt="news-left-4" />
            <img src={news_left_5} className={`news-left-5 ${devtype === 1 ? 'mobile' : ''}`} alt="news-left-5" />

            <img src={news_right_1} className={`news-right-1 ${devtype === 1 ? 'mobile' : ''} ${classNewMove}`} alt="news-right-1" />
            <img src={news_right_2} className={`news-right-2 ${devtype === 1 ? 'mobile' : ''} ${classNewMove}`} alt="news-right-2" />
            <img src={news_right_3} className={`news-right-3 ${devtype === 1 ? 'mobile' : ''}`} alt="news-right-3" />
            <img src={news_right_4} className={`news-right-4 ${devtype === 1 ? 'mobile' : ''}`} alt="news-right-4" />

            <div className="news-content">

                <div className={`news-center ${devtype === 1 ? 'mobile' : ''}`}>
                    <VisibilityObserver effect="fade-up" threshold={0.3} duration={1000} delay={400}>
                    <div className={`news-header ${devtype === 1 ? 'mobile' : ''}`}>
                        <div className={`title ${devtype === 1 ? 'mobile' : ''}`}>
                            <img className={`news-icon ${devtype === 1 ? 'mobile' : ''}`} src={news_title} alt="News" />
                        </div>
                        <a href="/newslist" className={`more ${devtype === 1 ? 'mobile' : ''}`}>
                            <img src={news_all} alt="新闻一览" />
                        </a>
                    </div>
                    </VisibilityObserver>
                    <VisibilityObserver effect="fade-up" threshold={0.3} duration={1000} delay={400}>
                    <div className={`news-list ${devtype === 1 ? 'mobile' : ''}`}>
                        {newsData.map((item, index) => (
                            <div onClick={() => cli_newDetail(item.news_id)} key={index} className={`news-item ${devtype === 1 ? 'mobile' : ''}`}>
                                <div className={`news-item-child ${devtype === 1 ? 'mobile' : ''}`}>
                                    <div
                                        className={`news-tag ${devtype === 1 ? 'mobile' : ''}`}>{newsOptions[item.type]}</div>
                                    <div
                                        className={`news-date ${devtype === 1 ? 'mobile' : ''}`}>{item.date}</div>
                                </div>
                                <div className={`news-text ${devtype === 1 ? 'mobile' : ''}`}>{item.title}</div>
                            </div>
                        ))}
                    </div>
                    </VisibilityObserver>


                </div>

            </div>
        </div>
        </VisibilityObserver>
    )
}

// AboutUs
const AboutUs = (props) => {
    const {devtype} = props;
    const [showxiaohongshu, setShowxiaohongshu] = useState(false);
    const [showweixin, setShowweixin] = useState(false);
    const [showshipinhao, setShowshipinhao] = useState(false);
    const [showweibo, setShowweibo] = useState(false);

    const cli_weibo = (e) => {
        e.stopPropagation();
        if (devtype === 1) {
            window.location.href = "/qrcode/3";
        } else {
            setShowweibo(!showweibo);
        }

    }

    const cli_shipinhao = (e) => {
        e.stopPropagation();
        if (devtype === 1) {
            window.location.href = "/qrcode/1";
        } else {
            setShowshipinhao(!showshipinhao);
        }

    }
    const cli_weixin = (e) => {
        e.stopPropagation();
        if (devtype === 1) {
            window.location.href = "/qrcode/0";
        } else {
            setShowweixin(!showweixin);
        }
    }

    const cli_xiaohongshu = (e) => {
        e.stopPropagation();
        if (devtype === 1) {
            window.location.href = "/qrcode/2";
        } else {
            setShowxiaohongshu(!showxiaohongshu);
        }
    }

    const cli_clo_qr = () => {

        setShowweixin(false)
        setShowxiaohongshu(false);
        setShowshipinhao(false);
        setShowweibo(false);
    }
    return (
        <div onClick={cli_clo_qr} className={`about-us ${devtype === 1 ? 'mobile' : ''}`}>
            <div className="about-us-viewport">
                <div className="viewport-content">
                    <div className="about-us-bg">
                        <img src={aboutus_bg} alt="background" className="bg-image" />
                        <div className={`bg-info ${devtype === 1 ? 'mobile' : ''}`}>
                            <div className={`slogan ${devtype === 1 ? 'mobile' : ''}`}>
                                <img src={devtype === 1 ? size_4_mobile : size_4} alt="Always for Delicious and Happiness" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`contact-section-container ${devtype === 1 ? 'mobile' : ''}`}>
                <div className={`contact-section ${devtype === 1 ? 'mobile' : ''}`}>
                    <div className={`contact-left ${devtype === 1 ? 'mobile' : ''}`}>
                        <VisibilityObserver effect="fade-up" threshold={0.3} duration={1000} delay={100}>
                        <div className={`title ${devtype === 1 ? 'mobile' : ''}`}>联系我们</div>
                        </VisibilityObserver>
                        <VisibilityObserver effect="fade-up" threshold={0.3} duration={1000} delay={100}>
                        <div className={`subtitle ${devtype === 1 ? 'mobile' : ''}`}>CONTACT</div>
                        </VisibilityObserver>
                        <div className="buttons">
                            <VisibilityObserver effect="fade-up" threshold={0.3} duration={1000} delay={100}>
                            <button className={`contact-btn ${devtype === 1 ? 'mobile' : ''}`}>
                                <a href="/index/company/contact.html">联系方式</a>
                            </button>
                            </VisibilityObserver>
                            <VisibilityObserver effect="fade-up" threshold={0.3} duration={1000} delay={100}>
                            <button className={`contact-btn ${devtype === 1 ? 'mobile' : ''}`}>
                                <a href="/index/business/index.html">业务咨询</a>
                            </button>
                            </VisibilityObserver>
                        </div>
                    </div>
                    <div className={`contact-right ${devtype === 1 ? 'mobile' : ''}`}>
                        <VisibilityObserver effect="fade-up" threshold={0.3} duration={1000} delay={100}>
                        <div className={`title ${devtype === 1 ? 'mobile' : ''}`}>社媒/店铺</div>
                        </VisibilityObserver>
                        <VisibilityObserver effect="fade-up" threshold={0.3} duration={1000} delay={100}>
                        <div className={`subtitle ${devtype === 1 ? 'mobile' : ''}`}>SOCIALMEDIA / ONLINESHOP</div>
                        </VisibilityObserver>
                        <div className="icon-groups">
                            <VisibilityObserver effect="fade-up" threshold={0.3} duration={1000} delay={100}>
                            <div className={`icon-row ${devtype === 1 ? 'mobile' : ''}`}>
                                <div className={`icon-name ${devtype === 1 ? 'mobile' : ''}`}>好侍官方账号</div>
                                <img onClick={cli_weixin} src={wechat_icon_white} alt="WeChat" className={`social-icon ${devtype === 1 ? 'mobile' : ''}`} />
                                <img onClick={cli_shipinhao} src={wechatvideo_icon_white} alt="WeChat Video" className={`social-icon ${devtype === 1 ? 'mobile' : ''}`} />
                                <img onClick={cli_xiaohongshu} src={xhs_icon_white} alt="Xiaohongshu" className={`social-icon ${devtype === 1 ? 'mobile' : ''}`} />
                                <img onClick={cli_weibo} src={weibo_icon_white} alt="Weibo" className={`social-icon ${devtype === 1 ? 'mobile' : ''}`} />
                            </div>
                            </VisibilityObserver>
                            <VisibilityObserver effect="fade-up" threshold={0.3} duration={1000} delay={100}>
                            <div className={`icon-row ${devtype === 1 ? 'mobile' : ''}`}>
                                <div className={`icon-name ${devtype === 1 ? 'mobile' : ''}`}>好侍官方店铺</div>
                                <a href="https://z.douyin.com/p53t?scheme=snssdk1128%3A%2F%2Fgoods%2Fstore%3Fsec_shop_id%3DlxYptmZY%26entrance_location%3Ddou_shop_ad_101_2%26tab_id%3D16%26url_maker%3Dshop_sdk"><img src={tiktok_icon_white} alt="TikTok" className={`social-icon ${devtype === 1 ? 'mobile' : ''}`} /></a>
                                <a href="https://haoshishipin.tmall.com/shop/view_shop.htm"><img src={tmall_icon_white} alt="Tmall" className={`social-icon ${devtype === 1 ? 'mobile' : ''}`} /></a>
                                <a href="https://mall.jd.com/index-190008.html"><img src={jd_icon_white} alt="JD" className={`social-icon ${devtype === 1 ? 'mobile' : ''}`} /></a>
                                <a href="https://mobile.yangkeduo.com/mall_page.html?refer_share_uin=LDVQ3FQQ5EUFRWZB62H2OUQO4M_GEXDA&amp;refer_share_id=k2CghMHgUMRpZ45axMjmYxeC7IR5yd0S&amp;msn=q67rxhgwr2bpeq5gn43jfwfism_axbuy&amp;_wv=41729&amp;refer_share_channel=copy_link&amp;has_decoration=1&amp;mall_id=378996690&amp;_wvx=10"><img src={pdd_icon_white} alt="Pinduoduo" className={`social-icon ${devtype === 1 ? 'mobile' : ''}`} /></a>
                            </div>
                            </VisibilityObserver>
                        </div>

                        <div className={`icon-qr icon-qr-weixin ${showweixin ? 'show' : ''}`}>

                            <div className="qrcodeLeft__list">
                                <div>家庭用微信</div>
                                <div>
                                    <img src={jiating_weixin_qr} className="shipinhao_qr" alt="jiating_weixin_qr" />
                                </div>
                            </div>
                            <div className="qrcodeLeft__list">
                                <div>业务用微信</div>

                                <img src={yewu_weixin_qr} className="shipinhao_qr" alt="yewu_weixin_qr" />

                            </div>
                        </div>

                        <div className={`icon-qr icon-qr-xiaohongshu ${showxiaohongshu ? 'show' : ''}`}>
                            <div className="qrcodeLeft__list">
                                <div>官方用小红书</div>
                                <img src={xiaohongshu_qr} className="xiaohongshu_qr" alt="xiaohongshu_qr" />
                            </div>
                        </div>
                        <div className={`icon-qr icon-qr-shipinhao ${showshipinhao ? 'show' : ''}`}>
                            <div className="qrcodeLeft__list">
                                <div>视频号</div>
                                <img src={shipinhao_qr} className="shipinhao_qr" alt="shipinhao_qr" />
                            </div>
                        </div>
                        <div className={`icon-qr icon-qr-weibo ${showweibo ? 'show' : ''}`}>
                            <div className="qrcodeLeft__list">
                                <div>官方微博</div>
                                <img src={weibo_qr} className="weibo_qr" alt="weibo_qr" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const Footer = (props) => {
    const { devtype } = props;
    const [showTopButton, setShowTopButton] = useState(false);

    React.useEffect(() => {
        const handleScroll = () => {
            // 当滚动超过200px时显示按钮
            setShowTopButton(window.scrollY > 200);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    const menuItems = [
        {
            title: 'TOP',
            link: '#'
        },
        {
            title: '商品介绍',
            subItems: [
                { title: '咖喱调料类', link: '/productor?type=0#section-0',color:'',size:'',weight:'', },
                { title: '软罐头食品', link: '/productor?type=0#section-1',color:'',size:'',weight:'', },
                { title: '西餐调料类', link: '/productor?type=0#section-2',color:'',size:'',weight:'', },
                { title: '业务用商品', link: '/productor?type=1',color:'',size:'',weight:'', }
            ],
            link: '/productor',
        },
        {
            title: '好侍菜谱',
            subItems: [
                { title: '亲子咖喱', link: '/cookbook?category=1',color:'',size:'',weight:'', },
                { title: '节日特辑', link: '/cookbook?category=2',color:'',size:'',weight:'', },
                { title: '百搭咖喱', link: '/cookbook?category=3',color:'',size:'',weight:'', },
                { title: '快手咖喱', link: '/cookbook?category=4',color:'',size:'',weight:'', },
                { title: '家庭西餐', link: '/cookbook?category=5',color:'',size:'',weight:'', }
            ],
            link: '/cookbook'
        },
        {
            title: '关于好侍',
            subItems: [
                { title: '公司沿革', link: '/index/company/history.html',color:'',size:'',weight:'', },
                { title: '集团概要', link: '/index/company/purpose.html',color:'',size:'',weight:'', },
                { title: '市场营销网络', link: '/index/company/network.html',color:'',size:'',weight:'', }
            ],
            link: '/index/company/index.html',
        },
        {
            title: '业务合作',
            link: '/index/business/index.html'
        },
        {
            title: '日本好侍',
            subItems: [
                { title: '站点地图', link: '/index/company/sitemap.html',color:'#d70013',size:'16px',weight:'bold', },
                { title: '隐私条款', link: '/index/company/privacy.html',color:'#d70013',size:'16px',weight:'bold', },
                { title: '使用规则', link: '/index/company/ruler.html',color:'#d70013',size:'16px',weight:'bold', }
            ],
            link: 'https://housefoods-group.com/',
        },

    ];

    return (
        <div className="footer">

            <div className={`top-up ${devtype === 1 ? 'mobile' : ''} ${showTopButton ? 'show' : ''}`} onClick={scrollToTop}>
                <img src={footer_topup} alt="Back to top" />
            </div>
            <div className="footer-content">
                <VisibilityObserver effect="fade-up" threshold={0.3} duration={1000} delay={100}>
                <div className={`footer-logo ${devtype === 1 ? 'mobile' : ''}`}>
                    <img src={logo} alt="House Foods"/>
                </div>
                </VisibilityObserver>
                <div className={`footer-nav ${devtype === 1 ? 'mobile' : ''}`}>
                    {menuItems.map((item, index) => (
                        <div key={index} className="nav-group">
                            {item.link ? (
                                <VisibilityObserver effect="fade-up" threshold={0.3} duration={1000} delay={100}>
                                <a href={item.link} className="nav-title">{item.title}</a>
                                </VisibilityObserver>
                            ) : (
                                <VisibilityObserver effect="fade-up" threshold={0.3} duration={1000} delay={100}>
                                <div className="nav-title">{item.title}</div>
                                </VisibilityObserver>
                            )}
                            {item.subItems && (
                                <div className="sub-items">
                                    {item.subItems.map((subItem, subIndex) => (
                                        <VisibilityObserver effect="fade-up" threshold={0.3} duration={1000} delay={400} key={subIndex}>
                                            <a key={subIndex} href={subItem.link}
                                            className={`sub-item ${subItem.color === '' ? '' : 'sub-items-red'}`}>
                                                {subItem.title}
                                            </a>
                                        </VisibilityObserver>
                                    ))}
                                </div>
                            )}
                        </div>
                    ))}
                    {/*<VisibilityObserver effect="fade-up" threshold={0.3} duration={1000} delay={100}>*/}
                    {/*<div className="nav-group">*/}
                    {/*    <img className="footer-chengzhang" src={footer_chengzhang} alt="chengzhang"/>*/}
                    {/*</div>*/}
                    {/*</VisibilityObserver>*/}
                </div>
                {/*<VisibilityObserver effect="fade-up" threshold={0.3} duration={1000} delay={100}>*/}
                {/*<div className={`d-footer-chengzhang ${devtype === 1 ? 'mobile' : ''}`}>*/}
                {/*    <img src={footer_chengzhang} alt="chengzhang"/>*/}
                {/*</div>*/}
                {/*</VisibilityObserver>*/}
            </div>
            <VisibilityObserver effect="fade-up" threshold={0.3} duration={1000} delay={100}>
            <div className={`copyright ${devtype === 1 ? 'mobile' : ''}`}>
                <div>沪公网安备 31010502001878</div>
                <div>Copyright© 2025 House Foods China Inc.</div>
            </div>
            </VisibilityObserver>
        </div>
    )
}



const Home = () => {
    const [devtype, setDevtype] = useState(device()); // 1: 手机端，2: 平板端，3: 电脑端
    const [videoLoaded, setVideoLoaded] = useState(false);
    const [currentCaipuIndex, setCurrentCaipuIndex] = useState(0);
    const [isAnimationComplete, setIsAnimationComplete] = useState(false);
    const [shouldStartCaipuAnimation, setShouldStartCaipuAnimation] = useState(false);
    const [homeData, setHomeData] = useState(null);
    console.log(`device type => ${devtype}`);

    useEffect(() => {
        const fetchHomeData = async () => {
            try {
                const homeDataLocal = await getHomeData();
                console.log('homeDataLocal', homeDataLocal);
                setHomeData(homeDataLocal);
            } catch (error) {
                console.error('Failed to fetch home data:', error);
            }
        };
        fetchHomeData();
    }, []);

    useEffect(() => {
        const updateDevtype = () => setDevtype(device());
        updateDevtype();
        window.addEventListener('resize', updateDevtype);
        window.addEventListener('orientationchange', updateDevtype);
        return () => {
            window.removeEventListener('resize', updateDevtype);
            window.removeEventListener('orientationchange', updateDevtype);
        };
    }, []);

    // 序列图动画效果 - 每50毫秒切换一张图片，不重复循环
    useEffect(() => {
        if (!shouldStartCaipuAnimation || isAnimationComplete) return; // 如果动画未开始或已完成，不再执行

        const interval = setInterval(() => {
            setCurrentCaipuIndex((prevIndex) => {
                const nextIndex = prevIndex + 1;
                if (nextIndex >= caipuImages.length) {
                    // 动画完成，停止定时器
                    setIsAnimationComplete(true);
                    clearInterval(interval);
                    return prevIndex; // 保持在最后一张图片
                }
                return nextIndex;
            });
        }, 50); // 每50毫秒切换一张图片

        return () => clearInterval(interval);
    }, [shouldStartCaipuAnimation, isAnimationComplete]);

    const handleVideoLoad = (loaded) => {
        setVideoLoaded(loaded);
    };

    // 处理VisibilityObserver动画完成回调
    const handleVisibilityObserverEnded = () => {
        setShouldStartCaipuAnimation(true);
    };

    return (
        <div style={{ backgroundColor: 'transparent' }}>
            {/* 底部视频 */}
            <HomeVideo devtype={devtype} onVideoLoad={handleVideoLoad} />

            {/* 右侧菜单 */}
            <RightMenu devtype={devtype} />

            {/* logo header */}
            <LogoHeader devtype={devtype} />

            <div style={{ backgroundColor: '#FFC107' }}>
                {/* Banner 轮播 */}
                <Banner devtype={devtype} homeData={homeData} videoLoaded={videoLoaded} />

                {/* 咖喱课堂 */}
                <Classroom devtype={devtype} />

                {/* 全部菜谱 */}
                <AllCookbook devtype={devtype} currentCaipuIndex={currentCaipuIndex} onVisibilityObserverEnded={handleVisibilityObserverEnded} />

                {/* 全部食材 */}
                <AllFoods devtype={devtype} />

                {/* 商品介绍 */}
                <ProductIntro devtype={devtype} />

                {/* 了解好侍 */}
                <AboutHs devtype={devtype} />
                
                {/* 新闻中心 */}
                <News devtype={devtype} homeData={homeData}/>
            </div>

            {/* 关于我们 */}
            <AboutUs devtype={devtype} />

            {/* 底部 */}
            <Footer devtype={devtype} />
        </div>
    )
}

export default Home;
